import { render, staticRenderFns } from "./beauty.vue?vue&type=template&id=d67d9f7c&scoped=true&"
import script from "./beauty.vue?vue&type=script&lang=js&"
export * from "./beauty.vue?vue&type=script&lang=js&"
import style0 from "./beauty.vue?vue&type=style&index=0&id=d67d9f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67d9f7c",
  null
  
)

export default component.exports